import { Component, Input } from '@angular/core';
import { ICONS_BASE_PATH } from './icons-base-path';

@Component({
  selector: 'app-ikea-icon',
  templateUrl: './ikea-icon.component.html',
  styleUrls: ['./ikea-icon.component.scss'],
})
export class IkeaIconComponent {
  @Input() iconName: string;

  @Input() width = 'auto';

  @Input() height = 'auto';

  iconPath() {
    return `${ICONS_BASE_PATH}/${this.iconName}.svg`;
  }
}
